<template>
  <div>
    <div id="mainWrap">
      <!-- Mobile Filter Modal -->
      <MobileFilterModal
        v-if="showMobileFilters"
        ref="mobileFilter"
        :qmiDetails="qmiDetails"
        :communityHomePlans="communityHomePlans"
        :homeTypeList="homeTypeLists"
        :listHomeTypeMobileFilter="listHomeTypeMobileFilter"
        :listPlanNameMobileFilter="listPlanNameMobileFilter"
        :qmiFilterListMobileFilter="qmiFilterListMobileFilter"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :minPriceRangeMobileFilter="minPriceRangeMobileFilter"
        :maxPriceRangeMobileFilter="maxPriceRangeMobileFilter"
        :showMinPriceRangeMobileFilter="showMinPriceRangeMobileFilter"
        :showMaxPriceRangeMobileFilter="showMaxPriceRangeMobileFilter"
        :showPriceRangeMobileFilter="showPriceRangeMobileFilter"
        :enableMobileApply="enableMobileApply"
        :homeTypeCount="platMapSidebar.homeTypeCount"
        :planPriceExsist="planPriceExsist"
        @toggleMobileFilterModalVisibility="toggleMobileFilterModalVisibility"
        @applyMobileFilters="applyMobileFilters"
        @clearMobileFilters="clearMobileFilters"
        @updatePriceRangeMobile="updatePriceRangeMobile"
      />

      <!-- Plat Map Main -->
      <PlatMapMain
        v-if="!!platmap.url && !lodash.isEmpty(lotDetails) && !loading"
        ref="platMapMain"
        :levels="actualLevels"
        :activeLevel="activeLevel"
        :underlay="platmap.underlay_on"
        :lots="lotDetails.neighborhoods"
        :amenities="lotDetails.amenity"
        :svg="platmap.svg_html"
        :centerLat="platmap.center_latitude"
        :centerLong="platmap.center_longitude"
        :neighborhoodCenterLat="selectedNeighborhoodCenterLatitude"
        :neighborhoodCenterLong="selectedNeighborhoodCenterLongitude"
        :swCornerLong="platmap.sw_corner_longitude"
        :swCornerLat="platmap.sw_corner_latitude"
        :neCornerLong="platmap.ne_corner_longitude"
        :neCornerLat="platmap.ne_corner_latitude"
        :mapDefaultZoom="platmap.zoom_level"
        :selectedHomePlanId="selectedHomePlanId"
        :selectedJobNum="selectedJobNum"
        :listPlanId="listPlanId"
        :neighborhoods="neighborhoods"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :neighborhoodId="neighborhoodId"
        :communityId="communityId"
        :isKioskMode="isKioskMode"
        :listPlanNameId="listPlanNameId"
        :futureHomePlans="futureHomePlans"
        :homeplans="sidebar.data"
        :hoverNeighborZoomLevel="hoverNeighborZoomLevel"
        :isDisableHoverNeighbor="isDisableHoverNeighbor"
        :centerMap="centerMap"
        :qmiDetails="qmiDetails"
        @autoSelectLevel="autoSelectLevel"
        @showPlanFutureLotFlyout="
          (payload) => emit('showPlanFutureLotFlyout', payload)
        "
        @hideSibling="hideSibling"
        @setAmenities="(payload) => emit('setAmenities', payload)"
        @handleVisitClick="handleVisitClick"
        @hideHeader="hideHeader"
        @hideFooter="hideFooter"
        @showHeader="showHeader"
        @showFooter="showFooter"
        @showSidebar="showSidebar"
        @hideSidebar="hideSidebar"
        @disableZoomIn="disableZoomIn"
        @disableZoomOut="disableZoomOut"
        @loadLotInfo="loadLotInfo"
        @cleanHomeId="cleanHomeId"
        @loadAminityInfo="loadAminityInfo"
        @closeLotInfo="emit('closeLotInfo')"
        @closeAmenityInfo="emit('closeAmenityInfo')"
        @calculateContactInfoTopPosition="
          emit('calculateContactInfoTopPosition')
        "
        @calculateSoldLotsPercentage="calculateSoldLotsPercentage"
        @setZoomLevelMapPage="(payload) => emit('setZoomLevelMapPage', payload)"
        @updateLotInfo="(payload) => emit('updateLotInfo', payload)"
        @updateNotOnlyReservedPlan="updateNotOnlyReservedPlan"
        @setselectQmiData="(payload) => emit('setselectQmiData', payload)"
        @updateFooterData="updateFooterData"
      />
      <!-- Plat Toolbar -->
      <PlatToolbar
        v-if="!!platmap.url && !lodash.isEmpty(header.data) && !loading"
        ref="platMapToolbar"
        :headerOpen="header.open"
        :zoomOutDisabled="zoomOutDisabled"
        :zoomInDisabled="zoomInDisabled"
        :isKioskMode="isKioskMode"
        :toolbar="toolbar"
        @zoomIn="zoomIn"
        @zoomOut="zoomOut"
        @autoFit="autoFit"
        @handlePrintClick="handlePrintClick"
        @calculateContactInfoTopPosition="
          emit('calculateContactInfoTopPosition')
        "
        @toggleToolbar="toggleToolbar"
      />
      <ElevationModal
        v-if="isSalesOrLandView"
        :areaId="areaId"
        :showModal="showPlanModal"
        :selectedPlan="selectedPlan"
        :selectedLotInfo="selectedLotIdInfoData"
        :hasAvailableLots="hasAvailableLots"
        @closeModal="closePlanDetails"
      />

      <!-- Plat Sidebar -->
      <PlatSidebar
        ref="platMapSidebar"
        :isOpenElevationModal="isOpenElevationModal"
        :areaName="areaName"
        :communityName="communityName"
        :isFetchedData="isFetchedData"
        :initialHomePlanCount="initialHomePlanCount"
        :headerOpen="header.open"
        :headerData="header.data"
        :footerOpen="footer.open"
        :sidebarOpen="sidebar.open"
        :homeplans="sidebar.data"
        :qmiDetails="qmiDetails"
        :selectedJobNum="selectedJobNum"
        :neighborhoods="neighborhoods"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :selectedHomePlanIds="selectedHomePlanIds"
        :selectedHomePlanId="selectedHomePlanId"
        :selectedLotStatus="selectedLotStatus"
        :selectedLotId="selectedLotId"
        :availableSites="onChangeNeighbourhoodCount"
        :availableLots="availableLots"
        :neighborhoodId="neighborhoodId"
        :isKioskMode="isKioskMode"
        :soldPercentage="soldPercentage"
        :neighborhoodsPlanQmiCount="neighborhoodsPlanQmiCount"
        :lotsCount="neighborhoodLotsCount"
        :communityHomePlans="communityHomePlans"
        :totalMobileFilterApplied="totalMobileFilterApplied"
        :notReservedPlan="notReservedPlan"
        :coordinates="platmap.neighborhoods"
        :futureHomePlans="futureHomePlans"
        :planAttachedFutureLot="planAttachedFutureLot"
        :svg="platmap.svg_html"
        :selectedLotIdInfo="selectedLotIdInfoData"
        @hideSibling="hideSibling"
        @setFilterProperties="setFilterProperties"
        @setSortProperties="setSortProperties"
        @setQmiFilterProperties="setQmiFilterProperties"
        @toggleSidebar="toggleSidebar"
        @selectNeighborhood="selectNeighborhood"
        @setplanPriceExsist="setplanPriceExsist"
        @setHomePlanId="setHomePlanId"
        @closeLotInfo="emit('closeLotInfo')"
        @loadNeighborhood="(value) => emit('loadNeighborhood', value)"
        @setPlanNameListId="setPlanNameListId"
        @clearSelectedNeighborhoods="clearSelectedNeighborhoods"
        @updatefilteredHomePlans="updatefilteredHomePlans"
        @setPlanDetailsHometypeList="setPlanDetailsHometypeList"
        @applyMobileFilters="applyMobileFilters"
        @applyMobilePriceFilter="applyMobilePriceFilter"
        @setHomeTypeCount="(payload) => emit('setHomeTypeCount', payload)"
        @highlightNeighborhood="highlightNeighborhood"
        @sethoverNeighborZoomLevel="sethoverNeighborZoomLevel"
        @cleanHomeId="cleanHomeId"
        @updateNewHomePlanCount="updateNewHomePlanCount"
        @openModal="openPlanDetails"
        @closeModal="closePlanDetails"
      />

      <!-- Town Home Level -->
      <TownHomeLevel
        v-if="showHomeLevel"
        :levels="actualLevels"
        :class="isSalesOrLandView ? 'sales-mode' : 'customer-mode'"
        @selectedLevel="selectedLevel"
        ref="levelSelector"
      />

      <!-- Plat Footer -->
      <PlatFooter
        v-if="!!platmap.url && !isSalesOrLandView"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :open="footer.open"
        :futureHomePlans="futureHomePlans"
        :matchedSvgfooterData="matchedSvgfooterData"
        :data="footer.data"
        :amenities="amenities"
        :lotsCount="neighborhoodLotsCount"
        @toggleFooter="toggleFooter"
        @recalculateSidebarHeight="recalculateSidebarHeight"
        @setLegends="emit('setLegends')"
      />
      <Legend
        v-if="!loading && isSalesOrLandView && platmap.url"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :matchedSvgfooterData="matchedSvgfooterData"
        :data="footer.data"
        :amenities="amenities"
        :lotsCount="neighborhoodLotsCount"
        @setLegends="emit('setLegends')"
      />

      <!-- Mobile Filter Breadcrumb -->
      <div class="cp-filter">
        <div class="cp-filter-breadcrumb">
          <div class="arrow" @click="backPageAccess">
            <LongArrowLeftIcon />
          </div>
          <span class="cp-filter-title"
            >{{ header.data.community_name }} Community</span
          >
        </div>
        <i class="count-badge dsize" v-if="totalMobileFilterApplied">{{
          totalMobileFilterApplied
        }}</i>
        <div
          :class="[
            'cp-filter-filters',
            { disableFilter: !initialHomePlanCount },
          ]"
          @click="() => toggleMobileFilterModalVisibility()"
        >
          <FiltersIcon />
          <span>Filters</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isMobile, isTablet } from 'mobile-device-detect';
import lodash from 'lodash';
import html2canvas from 'html2canvas';
import FiltersIcon from '@/assets/icons/FiltersIcon.vue';
import {
  Header,
  HeaderData,
  Footer,
  FooterData,
  Platmap,
  LotDetails,
  SidebarHomePlan,
  Sidebar,
  LotPosition,
  Alert,
  Amenity,
  LotCount,
  NeighborhoodInfo,
  LotDetail,
  NeighborhoodPlatMap,
  LotCountNeighborhood,
  NeighborhoodSoldDetails,
  CommunityQmiDetails,
  QmiDetails,
  planDetails,
  QmiDays,
  NeighborhoodPlanQmiCounts,
  NeighborhoodHomePlans,
  LotInfo,
  NeighboorhoodCoords,
  QmiJobStatus,
  CommunityFutureHomePlans,
  ComparedSvgFooterData,
  Lot,
} from './../../types';
import {
  HomeType,
  HomeTypeCode,
  ModalType,
  Settings,
  Status,
  UrlFilterList,
} from './../../constant';
import PlatmapHeader from '../AppHeader.vue';
import PlatToolbar from '../AppToolBar.vue';
import PlatFooter from '../AppFooter.vue';
import PlatMapMain from '../PlatMapMain.vue';
import PlatSidebar from '../SideBar.vue';
import AppHeaderCircle from '../AppHeaderCircle.vue';
import MobileFilterModal from '../modal/MobileFilterModal.vue';
import TownHomeLevel from '../TownHomeLevel.vue';
import LongArrowLeftIcon from '@/assets/icons/LongArrowLeftIcon.vue';
import ElevationModal from '../modal/ElevationModal.vue';
import Legend from '../Legend.vue';
import {
  apiFetchHeaderDetails,
  apiFetchFooterDetails,
  apiFetchHomePlans,
  apiFetchQmiHomePlans,
  apiFetchLotsJobStatus,
} from './../../api';
import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  onMounted,
  watch,
  toRefs,
  inject,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import emitter from '@/mitt';
import { computeNeighborhoodSoldDetails } from '@/core/funcs';

// injector
const isSalesOrLandView = inject('setSelectionDropdown', ref(false));
const mode = inject('mode', ref(''));

const props = defineProps<{
  selectedNeighborhoodCenterLongitude: number;
  selectedNeighborhoodCenterLatitude: number;
  platmap: Platmap;
  lotDetails: LotDetails;
  neighborhoodId: string;
  communityId: string;
  selectedLotId: string;
  selectedHomePlanIds: string[];
  loading: boolean;
  siblingSelected: boolean;
  amenities: Amenity[];
  isKioskMode: boolean;
  neighborhoods: NeighborhoodInfo[];
  selectedNeighborhoodIds: string[];
  communityName: string;
  areaName: string;
  areaId: string;
  futureHomePlans: CommunityFutureHomePlans;
  selectedLotIdInfo: any;
  isFetchedData: boolean;
}>();
const {
  selectedNeighborhoodCenterLatitude,
  selectedNeighborhoodCenterLongitude,
  platmap,
  lotDetails,
  neighborhoodId,
  communityId,
  selectedLotId,
  selectedHomePlanIds,
  loading,
  siblingSelected,
  amenities,
  isKioskMode,
  neighborhoods,
  selectedNeighborhoodIds,
  communityName,
  areaName,
  areaId,
  futureHomePlans,
  selectedLotIdInfo,
  isFetchedData,
} = toRefs(props);
const emit = defineEmits([
  'setZoomLevelMapPage',
  'setHomeTypeCount',
  'showPlanFutureLotFlyout',
  'setLotId',
  'updateLotInfo',
  'setAllAmenities',
  'loadNeighborhood',
  'selectNeighborhood',
  'setNeighborhoodName',
  'setLegends',
  'setAmenities',
  'setUnderlay',
  'printPDF',
  'calculateContactInfoTopPosition',
  'handlePrintSelectionClick',
  'showLoader',
  'hideLoader',
  'handleCloseLotInfo',
  'closeAmenityInfo',
  'notFound',
  'openModal',
  'updateChatBotPosition',
  'setNeighborhoodAreaName',
  'setCommunityName',
  'setAminityId',
  'fetchPlatmap',
  'fetchPlatmapCoordinates',
  'setPrintModal',
  'clearSelectedNeighborhoods',
  'setselectQmiData',
  'closeLotInfo',
]);
const modal = ref<any>(null);
const refs = ref<any>(null);

const selectedHomePlanId = ref('');
const selectedLotStatus = ref('');
const selectedJobNum = ref('');
const zoomOutDisabled = ref(false);
const zoomInDisabled = ref(false);
const centerLatitude = ref(0);
const centerLongitude = ref(0);
const toolbar = ref(true);
const availableSites = ref(0);
const communityCode = ref('');
const showMobileFilters = ref(false);
const isMobilePriceApplied = ref(false);
const noPricePlanVisited = ref(false);
const planPriceExsist = ref(true);
const availableLots = ref(0);
const hasMobile = ref(!!(isMobile && !isTablet));
const onChangeNeighbourhoodCount = ref(0);
const totalMobileFilterApplied = ref(0);
const minPriceRangeMobileFilter = ref(0);
const maxPriceRangeMobileFilter = ref(0);
const showMinPriceRangeMobileFilter = ref(0);
const showMaxPriceRangeMobileFilter = ref(0);
const showPriceRangeMobileFilter = ref(false);
const changedMinValue = ref(Settings.MinValue);
const changedMaxValue = ref(Settings.MaxValue);
const initialHomePlanCount = ref(0);
const filterMaxPrice = ref(Settings.MaxValue);
const filterMinPrice = ref(Settings.MinValue);
const sortBy = ref('');
const enableMobileApply = ref(false);
const hoverNeighborZoomLevel = ref(0);
const isDisableHoverNeighbor = ref(false);
const activeLevel = ref('');

const filteredHomePlans = ref<any[]>([]);
const header = ref<Header>({ open: false, data: {} as HeaderData });
const footer = reactive<Footer>({ open: true, data: [] as FooterData[] });
const sidebar = reactive<Sidebar>({
  open: true,
  data: [] as SidebarHomePlan[],
});
const qmiDetails = ref<CommunityQmiDetails>({} as CommunityQmiDetails);
const listPlanId = ref<string[]>([]);
const soldPercentage = ref<NeighborhoodSoldDetails[]>([]);
const neighborhoodsPlanQmiCount = ref<NeighborhoodPlanQmiCounts[]>([]);
const listHomeTypeMobileFilter = ref<string[]>([]);
const listPlanNameMobileFilter = ref<string[]>([]);
const qmiFilterListMobileFilter = ref<QmiDays[]>([]);
const lotsCount = reactive<LotCount>({
  available: 0,
  model: 0,
  quickmovein: 0,
  sold: 0,
  reserved: 0,
});
const neighborhoodLotsCount = ref<LotCountNeighborhood[]>([]);
const listPlanNameId = ref<string[]>([]);
const homeTypeLists = ref(new Set<string>());
const communityHomePlans = ref<SidebarHomePlan[]>([]);
const neighborhoodHomePlans = ref<NeighborhoodHomePlans[]>([]);
const filterHomeTypeList = ref<string[]>([]);
const filterPlanNameList = ref<string[]>([]);
const qmiFilterList = ref<QmiDays[]>([]);
const notReservedPlan = ref(Array<string>([]));
const centerMap = ref<NeighboorhoodCoords>({} as NeighboorhoodCoords);
const planAttachedFutureLot = ref(new Set<string>());
const matchedSvgfooterData = ref<ComparedSvgFooterData[]>([]);

const levelSelector = ref<any>(null);
const mobileFilter = ref<any>(null);
const platMapMain = ref<InstanceType<typeof PlatMapMain>>();
const platMapToolbar = ref<any>(null);
const platMapSidebar = ref<any>(null);
const selectedLotIdInfoData = ref({} as Lot);
const showPlanModal = ref(false);
const selectedPlan = ref({} as any);

const router = useRouter();
const route = useRoute();

const isOpenElevationModal = computed(
  () => isSalesOrLandView.value && showPlanModal.value
);

const hasAvailableLots = computed(() => {
  if (selectedNeighborhoodIds.value.length) {
    const count = neighborhoodLotsCount.value.find(
      (n) => n.neighborhoodId === selectedNeighborhoodIds.value[0]
    )?.available;
    return !!count && count > 0;
  }
  let total = 0;
  for (const n of neighborhoodLotsCount.value) {
    if (n?.available) total += n.available;
  }
  return total > 0;
});

const openPlanDetails = (payload: { type: string; plan: any }) => {
  showPlanModal.value = true;
  selectedPlan.value = payload.plan;
};
const closePlanDetails = () => {
  showPlanModal.value = false;
  selectedPlan.value = {};
  // cleanHomeId();
  // emit('closeLotInfo');
};
const cleanHomeId = () => {
  selectedHomePlanId.value = '';
  selectedJobNum.value = '';
  closePlanDetails();
};

const loadLotInfo = (payload: {
  lotId: string;
  homeplanIds: string[];
  lotPosition: any;
  status: string;
}) => {
  selectedHomePlanId.value = '';
  selectedJobNum.value = '';
  selectedLotStatus.value = payload.status;

  if (isMobile && platmap.value.underlay_on) {
    sidebar.open = false;
  }
  emit('setLotId', payload);
};

const selectNeighborhood = (neighborhoodId: string) => {
  autoSelectLevel('');
  activeLevel.value = '';
  emit('selectNeighborhood', neighborhoodId);
};

const loadAminityInfo = (payload: { amenityId: string; lotPosition: any }) => {
  emit('closeLotInfo');
  if (isMobile) sidebar.open = false;

  emit('setAminityId', payload.amenityId, payload.lotPosition);
};

const clearSelectedNeighborhoods = () => {
  if (hasMobile.value) clearMobileFilters();

  emit('clearSelectedNeighborhoods');
};

const updateNotOnlyReservedPlan = (notReserved: Array<string>) => {
  notReservedPlan.value = notReserved;
  sidebar.data = sidebar.data.filter((plan) =>
    notReservedPlan.value.includes(plan.plan_id)
  );
};

watch(listPlanNameId, (newVal) => {
  if (newVal.length && !newVal.includes(selectedHomePlanId.value)) {
    selectedHomePlanId.value = '';
  }
});

watch(
  selectedLotIdInfo,
  (newValue, prevValue) => {
    if (Object.keys(newValue).length) {
      selectedLotIdInfoData.value = selectedLotIdInfo.value.lot;
    } else {
      selectedLotIdInfoData.value = {} as Lot;
    }
  },
  {
    deep: true,
  }
);

watch(
  () => sidebar.open,
  (isOpen) => {
    if (isOpen && isMobile) {
      if (!hasMobile.value && refs.value?.platMapMain && platMapMain.value) {
        platMapMain.value.closeMapInfoWindow();
      }
      emit('closeLotInfo');
      emit('closeAmenityInfo');
    }
  }
);

const showHomeLevel = computed(() => {
  const selectedHomeType =
    header.value?.data?.sibling?.filter(
      (n) => n.id === selectedNeighborhoodIds.value[0]
    )?.[0]?.home_type || '';
  return (
    (!selectedHomeType?.length ||
      HomeType.includes(selectedHomeType.toLowerCase())) &&
    actualLevels.value.length
  );
});

const selectedLevel = (level: string) => {
  activeLevel.value = level;
};

const autoSelectLevel = (level: string) => {
  if (activeLevel.value !== level) {
    levelSelector.value?.setActiveLevel(level);
  }
};

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  disableHover: boolean;
  mapCenter: NeighboorhoodCoords;
}) => {
  const { zoomLevel, disableHover, mapCenter } = payload;
  hoverNeighborZoomLevel.value = zoomLevel;
  isDisableHoverNeighbor.value = disableHover;
  centerMap.value = mapCenter;
};

const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => {
  const currentNeighborhoodLines = document.getElementById(
    `LINE-${payload.neighborhoodId}`
  )?.children;
  if (currentNeighborhoodLines) {
    Array.from(currentNeighborhoodLines).forEach((line) => {
      Array.from(line.children).forEach((element) => {
        (element as HTMLElement).style.display = payload.display;
      });
    });
  }
};

const hideSibling = () => {
  if (header.value?.data?.sibling?.length) {
    header.value.data.sibling.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element && !selectedNeighborhoodIds.value.length) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'none' });
      } else if (element && !selectedNeighborhoodIds.value.includes(item.id)) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'none' });
      } else if (element && selectedNeighborhoodIds.value.includes(item.id)) {
        highlightNeighborhood({ neighborhoodId: item.id, display: 'flex' });
      }
    });
  }
};

const updateFooterData = (newMatchedSvgfooterData: ComparedSvgFooterData[]) => {
  matchedSvgfooterData.value = newMatchedSvgfooterData;
};

const communityLotCount = () => {
  if (neighborhoods.value.length > 1) {
    availableSites.value = 0;
    availableLots.value = 0;
    neighborhoodLotsCount.value.forEach((n) => {
      const availableGroup =
        (n.available || 0) +
        (n.quickmovein || 0) +
        (n.qmi || 0) +
        (n.future || 0);

      availableLots.value += n.available || 0;
      availableSites.value += availableGroup;
    });
  } else {
    const n = neighborhoodLotsCount.value[0];
    if (!n) return;

    const availableGroup =
      (n.available || 0) +
      (n.quickmovein || 0) +
      (n.qmi || 0) +
      (n.future || 0);

    availableLots.value = n.available || 0;
    availableSites.value = availableGroup;
  }
};
watch([selectedNeighborhoodIds], (newVal, oldVal) => {
  countMobileFiltersApplied();
  routeUpdate(newVal, oldVal);
  assignHomePlans();
});

watch(
  [
    filterPlanNameList,
    filterMaxPrice,
    filterMinPrice,
    filterHomeTypeList,
    sortBy,
    qmiFilterList,
  ],
  (newValues, oldValues) => {
    routeUpdate(newValues as any, oldValues as any);
  },
  {
    deep: true,
  }
);

watch(communityId, (newVal, _) => {
  resetCommunityRelatedInfo();
  if (newVal && newVal !== communityCode.value) {
    communityCode.value = newVal;
    fetchHeader();
  }
  if (isMobile) {
    footer.open = false;
  }
});

watch(
  neighborhoods,
  () => {
    setInitialPlansCountData();
  },
  {
    deep: true,
  }
);

const resetCommunityRelatedInfo = () => {
  sidebar.data = [];
  communityHomePlans.value = [];
  neighborhoodHomePlans.value = [];
  qmiDetails.value = {} as any;
  filteredHomePlans.value = [];
  initialHomePlanCount.value = 0;
  showPlanModal.value = false;
};

onBeforeMount(() => {
  if (communityId.value) {
    fetchHeader();
    if (isMobile) {
      footer.open = false;
    }
  }
});

onMounted(() => {
  emitter.on('communityUpdated', resetCommunityRelatedInfo);
  emitter.on('fetchNeighborhood', fetchHeader);
  if (isMobile && !isTablet) {
    setHeaderHeight();
  }
});

const updateNewHomePlanCount = (planId: string) => {
  const planAttachedLotsStatus =
    platMapMain.value?.getplanAttachedLotsStatus(planId);
  if (
    planAttachedLotsStatus?.size === 1 &&
    planAttachedLotsStatus.values().next().value === Status.FUTURE_HOME
  ) {
    planAttachedFutureLot.value.add(planId);
  }
};

const setHeaderHeight = () => {
  const mobileHeader = document.querySelector('.cp-filter') as HTMLDivElement;
  if (!mobileHeader) return;
  const mobileHeaderHeight = mobileHeader.offsetHeight;
  (document.querySelector('#mainWrap') as HTMLDivElement).style.setProperty(
    '--cpFilterHeight',
    `${mobileHeaderHeight}px`
  );
};

const setFilterProperties = (payload: {
  listHomeType: string[];
  listPlanName: string[];
  maxPrice: number;
  minPrice: number;
}) => {
  filterHomeTypeList.value = payload.listHomeType;
  filterPlanNameList.value = payload.listPlanName;
  filterMaxPrice.value = payload.maxPrice;
  filterMinPrice.value = payload.minPrice;
};
const setSortProperties = (sort: string) => {
  sortBy.value = sort;
};

const setQmiFilterProperties = (qmiDays: QmiDays[]) => {
  qmiFilterList.value = qmiDays;
};

const backPageAccess = () => {
  if (window.history.length) {
    window.close();
  }
};

const setplanPriceExsist = (exists: boolean) => {
  planPriceExsist.value = exists;
};

const updateMobilefilterCount = () => {
  if (
    isMobilePriceApplied.value &&
    !conditionShowPriceRange.value &&
    !planPriceExsist.value
  ) {
    totalMobileFilterApplied.value += 1;
  }
};
// const clearMobileFilterNoHomePlan = () => {
//   if (selectedNeighborhoodIds.value.length) {
//     const currentNeighborhood = neighborhoodHomePlans.value.filter(
//       (element) => element.neighborhoodId === selectedNeighborhoodIds.value[0]
//     );
//     if (currentNeighborhood.length && !currentNeighborhood[0].homePlans.length) {
//       clearMobileFilters();
//     }
//   }
// };

const toggleHeader = () => {
  header.value.open = !header.value.open;
};

const routeUpdate = (newValue: any, oldValue: any) => {
  if (newValue !== oldValue && !isSalesOrLandView.value) {
    router.push({ query: createRoutePath() }).catch(() => {});
  }
};

const createRoutePath = () => {
  const newQuery: Record<string, any> = { ...route.query };

  if (selectedNeighborhoodIds.value.length) {
    const currentNeighborhoodData = neighborhoods.value.find(
      (neighborhood) =>
        neighborhood.neighborhood_code === selectedNeighborhoodIds.value[0]
    );
    newQuery[UrlFilterList.NEIGHBORHOOD] =
      currentNeighborhoodData?.neighborhood_name.toLowerCase() || '';
  } else {
    newQuery[UrlFilterList.NEIGHBORHOOD] = [];
  }

  newQuery[UrlFilterList.PLAN_NAME] = filterPlanNameList.value ?? [];
  newQuery[UrlFilterList.HOME_TYPE] = filterHomeTypeList.value ?? [];

  if (sortBy.value.length) {
    newQuery[UrlFilterList.SORT_BY] = sortBy.value.toString() ?? [];
  }

  newQuery[UrlFilterList.QMI_FILTER] =
    qmiFilterList.value.map((qmi) => qmi.value) ?? [];
  newQuery[UrlFilterList.MAX_PRICE] =
    filterMaxPrice.value && filterMaxPrice.value !== Settings.MaxValue
      ? filterMaxPrice.value.toString()
      : [];

  newQuery[UrlFilterList.MIN_PRICE] =
    filterMinPrice.value && filterMinPrice.value !== Settings.MinValue
      ? filterMinPrice.value.toString()
      : [];

  return newQuery;
};

const toggleToolbar = () => {
  toolbar.value = !toolbar.value;
};

const toggleFooter = () => {
  footer.open = !footer.open;
  if (hasMobile.value) {
    sidebar.open = !footer.open;
  }
  emit('updateChatBotPosition', footer.open);
};
const toggleSidebar = () => {
  sidebar.open = !sidebar.open;
};
const setHomePlanId = (payload: { planId: string; jobNum: string }) => {
  const { planId, jobNum } = payload;
  filteredHomePlans.value.forEach((element) => {
    if (
      (element.plan_id === planId && jobNum === '') ||
      element.job_number === jobNum
    ) {
      selectedHomePlanId.value = planId;
      selectedJobNum.value = jobNum;
    }
  });
  if (!isSalesOrLandView.value) emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const hideSidebar = () => {
  sidebar.open = false;
};
const hideHeader = () => {
  toolbar.value = false;
  header.value.open = false;
};
const hideFooter = () => {
  footer.open = false;
};
const showFooter = () => {
  footer.open = true;
};
const showSidebar = () => {
  sidebar.open = true;
};
const showHeader = () => {
  toolbar.value = true;
  header.value.open = true;

  const timer = setTimeout(() => {
    if (platMapToolbar.value) {
      platMapToolbar.value.calculateToolbarTopPosition();
    }
    clearTimeout(timer);
  }, 10);
};
const zoomIn = () => {
  platMapMain.value?.svgZoomIn();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const zoomOut = () => {
  platMapMain.value?.svgZoomOut();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const autoFit = () => {
  platMapMain.value?.svgAutoFit();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
};
const setMapCenter = (x: number, y: number) => {
  platMapMain.value?.setMapCenterUsingPixel(x, y);
};
const handlePrintClick = () => {
  const sessionData = window.sessionStorage.getItem(Settings.SESSION_KEY);

  emit('closeLotInfo');
  emit('closeAmenityInfo');

  emit('handlePrintSelectionClick', {
    printOptionSelected: true,
    showHomeLevel: showHomeLevel.value,
    actualLevels: actualLevels.value,
    selectedLevel: activeLevel.value,
  });

  if (sessionData || isSalesOrLandView.value) {
    emit('openModal', ModalType.CROPPING_TOOL);
    emit('setPrintModal', true);
  } else {
    emit('openModal', ModalType.CONTACT_INFO);
  }
};
const handleVisitClick = () => {
  emit('closeLotInfo');

  emit('handlePrintSelectionClick', {
    printOptionSelected: false,
    showHomeLevel: showHomeLevel.value,
    actualLevels: actualLevels.value,
    selectedLevel: activeLevel.value,
  });
  emit('openModal', ModalType.CONTACT_INFO);
};

const setInitialPlansCountData = () => {
  neighborhoodsPlanQmiCount.value = [];
  neighborhoods.value.forEach((neighborhood) => {
    neighborhoodsPlanQmiCount.value.push({
      neighborhoodId: neighborhood.neighborhood_code,
      neighborhoodQmisCount: 0,
      neighborhoodPlansCount: 0,
    });
  });
};

const changeHomeType = () => {
  header.value.data.sibling.forEach((neighbor) => {
    if (Object.keys(HomeTypeCode).includes(neighbor.home_type)) {
      neighbor.home_type =
        HomeTypeCode[neighbor.home_type as keyof typeof HomeTypeCode];
    }
  });
};
const fetchHeader = async (hideErrorPage = false) => {
  try {
    emit('showLoader');
    neighborhoodsPlanQmiCount.value = [];
    setInitialPlansCountData();

    const neighborhoodId =
      selectedNeighborhoodIds.value[0] ??
      neighborhoods.value[0].neighborhood_code;
    const data = await apiFetchHeaderDetails(neighborhoodId);
    const { result } = data;

    header.value.data = result as HeaderData;
    communityCode.value = header.value.data.community_code;

    emit('setCommunityName', header.value.data.community_name);
    await emitter.emit('communitySelected', communityCode.value);
    changeHomeType();
    emit('setNeighborhoodAreaName', header.value.data.area_link_name);
    const neighborhoodCodes = header.value.data.sibling.map(
      (sibling) => sibling.id
    );

    await Promise.all([fetchHomePlans(neighborhoodCodes), fetchFooter()]);
    await emit('fetchPlatmap', {
      neighborhoodId,
      communityCode: communityCode.value,
      header: header.value.data,
    });
  } catch (error) {
    console.error('Error fetching header details:', error);
    emit('hideLoader');
    if (!hideErrorPage) {
      emit('notFound');
    }
  }
};

const resetHeaderData = () => {
  header.value = { open: false, data: {} as HeaderData };
};

const reorderLegendPositions = (legends: FooterData[]) => {
  // legends[2] = sold & legends[3] = reserved
  if (legends && legends.length > 3) {
    const swap = legends[2];
    legends[2] = legends[3];
    legends[3] = swap;
  }
  return legends;
};

const updateLegends = (legendArr: string[]) => {
  if (
    (!selectedNeighborhoodIds.value.length &&
      Object.keys(futureHomePlans.value).length) ||
    (selectedNeighborhoodIds.value[0] &&
      Object.keys(futureHomePlans.value).includes(
        selectedNeighborhoodIds.value[0]
      ))
  ) {
    legendArr.push(Status.FUTURE_HOME);
  }
};

const fetchFooter = async () => {
  try {
    const data = await apiFetchFooterDetails(communityCode.value, mode.value);
    let { result } = data;
    result = reorderLegendPositions(result);
    footer.data = result as FooterData[];

    if (result.length) {
      let legendArr: string[] = [];
      result.forEach((legend: FooterData) => legendArr.push(legend.status));
      updateLegends(legendArr);
      emit('setLegends', legendArr.toString());
    }
  } catch (error) {
    emit('setLegends', '');
    footer.data = [];
  }
};

const assignHomePlansNeighborhood = (data: SidebarHomePlan[]) => {
  neighborhoodHomePlans.value = [];
  const neighborhoodsWithHP: string[] = [];

  data.forEach((homePlan) => {
    if (neighborhoodsWithHP.includes(homePlan.neighborhood_code)) {
      const requiredNeighborhood = neighborhoodHomePlans.value.find(
        (neighborhood) =>
          neighborhood.neighborhoodId === homePlan.neighborhood_code
      );
      requiredNeighborhood?.homePlans.push(homePlan);
    } else {
      neighborhoodsWithHP.push(homePlan.neighborhood_code);
      neighborhoodHomePlans.value.push({
        neighborhoodId: homePlan.neighborhood_code,
        homePlans: [homePlan],
      });
    }
  });
};

const assignHomePlansCommunity = (data: SidebarHomePlan[]) => {
  communityHomePlans.value = [];

  for (const homePlan of data) {
    const existingPlan = communityHomePlans.value.find(
      (plan) => plan.plan_id === homePlan.plan_id
    );

    if (
      existingPlan &&
      homePlan.price_low_with_premium !== 0 &&
      (existingPlan.price_low_with_premium > homePlan.price_low_with_premium ||
        existingPlan.price_low_with_premium === 0)
    ) {
      // Remove old plan and push new one
      communityHomePlans.value.splice(
        communityHomePlans.value.indexOf(existingPlan),
        1
      );
      communityHomePlans.value.push(homePlan);
    } else if (!existingPlan) {
      communityHomePlans.value.push(homePlan);
    }
  }
};

const assignHomePlans = () => {
  initialHomePlanCount.value = 0;

  if (selectedNeighborhoodIds.value.length) {
    const selectedNeighborhoodHomePlan = neighborhoodHomePlans.value.find(
      (neighborhood) =>
        neighborhood.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    sidebar.data = selectedNeighborhoodHomePlan
      ? selectedNeighborhoodHomePlan.homePlans
      : [];
  } else {
    sidebar.data = communityHomePlans.value;
  }

  initialHomePlanCount.value += sidebar.data.length;

  if (selectedNeighborhoodIds.value.length) {
    const count =
      qmiDetails.value[selectedNeighborhoodIds.value[0]]?.length ?? 0;
    initialHomePlanCount.value += count;
  } else {
    for (const key of Object.keys(qmiDetails.value)) {
      initialHomePlanCount.value += qmiDetails.value[key].length;
    }
  }
};

const fetchHomePlans = async (neighborhoodCodes: string[]) => {
  try {
    const promises = neighborhoodCodes.map((neighborhoodCode) =>
      apiFetchHomePlans(neighborhoodCode, communityCode.value)
    );

    const responses = await Promise.all(
      promises.map((promise) => promise.catch((error) => error))
    );

    const data: SidebarHomePlan[] = [];

    responses.forEach((eachPromiseData, idx) => {
      if (eachPromiseData.result) {
        data.push(...(eachPromiseData.result.home_planes as SidebarHomePlan[]));
        setNeighborhoodPlansCount(
          neighborhoodCodes,
          eachPromiseData.result.home_planes,
          idx
        );
      } else {
        setNeighborhoodPlansCount(neighborhoodCodes, [], idx);
      }
    });

    assignHomePlansNeighborhood(data);
    assignHomePlansCommunity(data);

    qmiDetails.value = (await apiFetchQmiHomePlans(
      communityCode.value
    )) as CommunityQmiDetails;

    assignHomePlans();

    // Convert prices to integer
    for (const key of Object.keys(qmiDetails.value)) {
      for (const value of qmiDetails.value[key]) {
        value.price = parseInt(value.price);
        value.color = mode.value === 'customer' ? '#99b5c5' : '#9EB4C3';
      }
    }

    setNeighborhoodQmisCount();
  } catch (error) {
    sidebar.data = [];
  }
};

const setNeighborhoodPlansCount = (
  neighborhoodCodes: string[],
  neighborhoodPlansData: SidebarHomePlan[],
  idx: number
) => {
  const currentNeighborhoodId = neighborhoodCodes[idx];
  const neighborhoodCountData = neighborhoodsPlanQmiCount.value.find(
    (countData) => countData.neighborhoodId === currentNeighborhoodId
  );

  if (neighborhoodCountData) {
    neighborhoodCountData.neighborhoodPlansCount = neighborhoodPlansData.length;
  }
};

const setNeighborhoodQmisCount = () => {
  for (const [key, value] of Object.entries(qmiDetails.value)) {
    const neighborhoodCountData = neighborhoodsPlanQmiCount.value.find(
      (countData) => countData.neighborhoodId === key
    );
    if (neighborhoodCountData) {
      neighborhoodCountData.neighborhoodQmisCount = value.length;
    }
  }
};

const disableZoomIn = () => {
  zoomInDisabled.value = !zoomInDisabled.value;
};

const disableZoomOut = () => {
  zoomOutDisabled.value = !zoomOutDisabled.value;
};

const recalculateSidebarHeight = (height?: number) => {
  platMapSidebar.value?.calculateDynamicHeight(height);
};

const calculateSoldLotsPercentage = (
  lotsCountNeighborhood: LotCountNeighborhood[]
) => {
  neighborhoodLotsCount.value = lotsCountNeighborhood;
  communityLotCount();

  soldPercentage.value = [];

  // Sales/Land use the current sold-percentage definition; the customer plat
  // map keeps the legacy production definition (see computeNeighborhoodSoldDetails).
  const isSalesOrLandView = mode.value === 'sales' || mode.value === 'land';

  lotsCountNeighborhood.forEach((lotCount) => {
    soldPercentage.value.push(
      computeNeighborhoodSoldDetails(lotCount, isSalesOrLandView)
    );

    if (lotCount.neighborhoodId === selectedNeighborhoodIds.value[0]) {
      availableLots.value = lotCount.available;
      availableSites.value =
        (lotCount.available || 0) +
        (lotCount.quickmovein || 0) +
        (lotCount.qmi || 0) +
        (lotCount.future || 0);
    }
  });
};

const setPlanNameListId = (ids: string[]) => {
  listPlanId.value = ids.slice(0);
};

const updatefilteredHomePlans = (plans: any[]) => {
  filteredHomePlans.value = plans;
  onChangeNeighbourhoodCount.value =
    platMapMain.value?.countLotsFilterPlans(filteredHomePlans.value) ?? 0;

  // let isHomePlanAvailableLeftRail = false;
  // filteredHomePlans.value.forEach((element) => {
  //   if ((element.plan_id === selectedHomePlanId.value && selectedJobNum.value === "") ||
  //       (element.job_number === selectedJobNum.value)) {
  //     isHomePlanAvailableLeftRail = true;
  //     return false;
  //   }
  // });
  // if (!isHomePlanAvailableLeftRail) {
  //   selectedHomePlanId.value = "";
  //   selectedJobNum.value = "";
  // }
};

watch(
  [filteredHomePlans, () => platMapMain.value?.ready],
  ([plans, isReady]) => {
    if (isReady && platMapMain.value) {
      onChangeNeighbourhoodCount.value =
        platMapMain.value.countLotsFilterPlans(plans) ?? 0;
    }
  },
  { immediate: true }
);
const actualLevels = computed(() => {
  let levels: string[] = [];
  if (lotDetails.value.neighborhoods?.length) {
    lotDetails.value.neighborhoods.forEach((lotDetail) => {
      lotDetail.lots.forEach((lot) => {
        if (lot.level && !levels.includes(lot.level)) {
          levels.push(lot.level);
        }
      });
    });
  }
  levels = levels?.sort((a, b) => Number(b) - Number(a));
  return levels.length ? levels : [];
});
const conditionShowPriceRange = computed(() => {
  if (!initialHomePlanCount.value) return true;

  if (selectedNeighborhoodIds.value.length) {
    const currentSoldPercentage = soldPercentage.value.filter((element) =>
      selectedNeighborhoodIds.value.includes(element.neighborhoodId)
    );
    return currentSoldPercentage.length &&
      currentSoldPercentage[0].soldPercentage
      ? currentSoldPercentage[0].soldPercentage >= 100
      : true;
  } else {
    const currentSoldPercentage = soldPercentage.value.filter(
      (element) => element.soldPercentage < 100
    );
    return !currentSoldPercentage.length;
  }
});
const toggleMobileFilterModalVisibility = (show = true) => {
  showMobileFilters.value = show;
  showPriceRangeMobileFilter.value = !conditionShowPriceRange.value
    ? show
    : false;
};
const setPlanDetailsHometypeList = (payload: {
  communityHomePlans: SidebarHomePlan[];
  homeTypeList: Set<string>;
  minPrice: number;
  maxPrice: number;
}) => {
  const {
    communityHomePlans: plans,
    homeTypeList,
    minPrice,
    maxPrice,
  } = payload;
  communityHomePlans.value = plans;
  homeTypeLists.value = homeTypeList;
  minPriceRangeMobileFilter.value = showMinPriceRangeMobileFilter.value =
    minPrice;
  maxPriceRangeMobileFilter.value = showMaxPriceRangeMobileFilter.value =
    maxPrice;
};

const updatePriceRangeMobile = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  changedMinValue.value = payload.minValue;
  changedMaxValue.value = payload.maxValue;
  enableMobileApply.value =
    payload.minValue > minPriceRangeMobileFilter.value ||
    payload.maxValue < maxPriceRangeMobileFilter.value;
};

const applyMobilePriceFilter = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  updatePriceRangeMobile(payload);
  minMaxValuePriceRangeMobileFilter();
  showPriceRangeMobileFilter.value = true;
  totalMobileFilterApplied.value += 1;
  isMobilePriceApplied.value = true;
};
const minMaxValuePriceRangeMobileFilter = () => {
  let priceMinValueMobileFilter = Settings.MinValue;
  showMinPriceRangeMobileFilter.value = minPriceRangeMobileFilter.value;

  let priceMaxValueMobileFilter = Settings.MaxValue;
  showMaxPriceRangeMobileFilter.value = maxPriceRangeMobileFilter.value;

  if (
    changedMinValue.value > minPriceRangeMobileFilter.value ||
    changedMaxValue.value < maxPriceRangeMobileFilter.value
  ) {
    priceMinValueMobileFilter = showMinPriceRangeMobileFilter.value =
      changedMinValue.value;
    priceMaxValueMobileFilter = showMaxPriceRangeMobileFilter.value =
      changedMaxValue.value;
    isMobilePriceApplied.value = true;
  } else {
    isMobilePriceApplied.value = false;
  }

  return { min: priceMinValueMobileFilter, max: priceMaxValueMobileFilter };
};

const applyMobileFilters = (payload: {
  listPlanName: string[];
  listHomeType: string[];
  qmiFilterList: QmiDays[];
}) => {
  const { listHomeType, listPlanName, qmiFilterList } = payload;
  listHomeTypeMobileFilter.value = listHomeType;
  listPlanNameMobileFilter.value = listPlanName;
  qmiFilterListMobileFilter.value = qmiFilterList;

  const minMax = minMaxValuePriceRangeMobileFilter();

  countMobileFiltersApplied();

  platMapSidebar.value?.filterPlanNameHomeType({
    listHomeType,
    listPlanName,
    maxPrice: minMax.max,
    minPrice: minMax.min,
  });
  platMapSidebar.value?.setQmiDaysMobileFilter(qmiFilterList);
};
const clearMobileFilters = () => {
  changedMaxValue.value = showMaxPriceRangeMobileFilter.value =
    maxPriceRangeMobileFilter.value;
  changedMinValue.value = showMinPriceRangeMobileFilter.value =
    minPriceRangeMobileFilter.value;

  listHomeTypeMobileFilter.value = [];
  listPlanNameMobileFilter.value = [];
  qmiFilterListMobileFilter.value = [];
  isMobilePriceApplied.value = false;
  totalMobileFilterApplied.value = 0;

  platMapSidebar.value?.filterPlanNameHomeType({
    listHomeType: [],
    listPlanName: [],
    maxPrice: 0,
    minPrice: 0,
  });
  platMapSidebar.value?.setQmiDaysMobileFilter([]);
};

// Count applied mobile filters
const countMobileFiltersApplied = () => {
  totalMobileFilterApplied.value = 0;

  if (listHomeTypeMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;
  if (listPlanNameMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;
  if (qmiFilterListMobileFilter.value.length)
    totalMobileFilterApplied.value += 1;

  updateMobilefilterCount(); // ensure this function is also refactored for Composition API
};

defineExpose({
  listPlanNameMobileFilter,
  qmiFilterListMobileFilter,
  filterPlanNameList,
  filterMaxPrice,
  filterMinPrice,
  toolbar,
  recalculateSidebarHeight,
  showHeader,
  showFooter,
  showSidebar,
  hideFooter,
  hideHeader,
  handlePrintClick,
  applyMobileFilters,
  setFilterProperties,
  setMapCenter,
  resetHeaderData,
});
</script>

<style lang="scss" scoped>
.cp-filter {
  border-radius: 46px;
  background: $white;
  box-shadow: 0px 2px 3px 0px rgba(163, 131, 63, 0.13);
  padding: 10px 13px;
  position: fixed;
  left: 0;
  right: 0;
  top: 27px;
  margin-inline: auto;
  display: flex;
  align-items: center;
  column-gap: 8px;
  max-width: 337px;
  max-height: var(--mobileCommunityPill);
  z-index: map-get($z-index, embpopup);

  @include md {
    display: none;
  }

  &-title {
    @include font(15px, 700);
  }

  &-breadcrumb {
    display: flex;
    align-items: center;
    column-gap: 9px;
    color: $lime-green-new;

    &:after {
      content: '';
      background: $gray-900;
      height: 25px;
      width: 1px;
    }

    svg {
      flex-shrink: 0;
    }
  }

  &-filters {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    gap: 4px;
    color: $gray-600;
    font-size: 12px;
    font-weight: 700;
    border-radius: 22px;
    border: 0.7px solid var(--grey-300, rgba(53, 53, 53, 0.3));
    cursor: pointer;
    flex-shrink: 0;
  }

  .count-badge {
    --dsize: 20px;
    --dsizeBg: #a8b50a;
    @include font(12px, 700);
    position: absolute;
    right: 10px;
    top: 5px;
  }
}

.disableFilter {
  pointer-events: none;
  border: 0.7px solid rgba(53, 53, 53, 0.3);
  background: #b2b2b4;
}
</style>
